import type { SVGProps } from 'react'
import { cn } from '@/lib/utils'
import { BrandMark } from '@/components/ui/brand-mark'

/** Figma's mark on a paper tile. */
export function FigmaTile({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <span
      className={cn('inline-grid flex-none place-items-center bg-paper-deep', className)}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.29) }}
      aria-hidden
    >
      <BrandMark brand="figma" size={Math.round(size * 0.58)} />
    </span>
  )
}

/** Figma's mark, from the BrandMark registry. The square it fills is `height`
 *  (the glyph is two thirds as wide); kept for the import flow's callers. */
export function FigmaLogo({ height = 16, className }: Pick<SVGProps<SVGSVGElement>, 'width' | 'height' | 'className'>) {
  return <BrandMark brand="figma" size={Number(height)} className={className} />
}
